// Quyền trong đơn vị đang mở cho giao diện (docs/KE_HOACH_THANH_VIEN_DON_VI.md): chủ đơn vị — mọi thứ như trước;
// nhân viên — theo quyền chủ cấp (shops[].staff, đọc lại khi máy chủ báo 403 'staff.*'). Chỉ để ẩn nút / tắt truy vấn:
// máy chủ vẫn kiểm từng request. Giao diện cấp trên tắt cho Đại lý / CTV (docs/KE_HOACH_CHON_GIAO_DIEN_CAP_DUOI.md): chủ
// cũng không có quyền của giao diện đó; quyền nhân viên máy chủ đã lọc sẵn.
import { unitSpecAllows, workModesBlocking, type UnitAccessSpec } from '@shoptrack/common/unit-permissions'
import { useAuth, type Shop } from './auth'

export interface UnitCan {
  isStaff: boolean
  /** Có quyền theo `spec` (một quyền / { all } / { any }) không — chủ đơn vị có, trừ quyền của giao diện đã tắt */
  can: (spec: UnitAccessSpec) => boolean
  /** Thấy tiền (sổ tiền, giá vốn, cước, lợi nhuận) không */
  seesMoney: boolean
}

export function unitCanFor(shop: Shop | null | undefined): UnitCan {
  if (shop?.role !== 'staff') {
    const can = (spec: UnitAccessSpec) => !shop?.workModes || workModesBlocking(spec, shop.tenantType, shop.workModes).length === 0
    return { isStaff: false, can, seesMoney: true }
  }
  const perms = new Set(shop.staff?.permissions ?? [])
  const can = (spec: UnitAccessSpec) => unitSpecAllows(spec, perms)
  return { isStaff: true, can, seesMoney: perms.has('money.view') }
}

export function useUnitCan(): UnitCan {
  const auth = useAuth()
  return unitCanFor(auth.shops.find((s) => s.shopId === auth.activeShopId))
}
